import React, { useState } from "react";
import "./Prizes.css";

export default function Prizes() {
  const prizes = [
    {
      place: "1st Place",
      title: "Grand Champion",
      amount: "₹40,000",
      color: "#f2b01b",
      items: [
        "Championship Trophy",
        "Merit certificate"
      ],
    },
    {
      place: "2nd Place",
      title: "Runner-Up",
      amount: "₹30,000",
      color: "#b0b3bb",
      items: [
        "Runner-Up Trophy",
        "Merit certificate"
      ],
    },
  ];

  const awards = [
    { title: "Best Endurance", amount: "₹10000" },
    { title: "Runner-Up Endurance", amount: "₹5000" },
    { title: "Best Acceleration", amount: "₹10000" },
    { title: "Runner-Up Acceleration", amount: "₹5000" },
    { title: "Best Maneuverbility", amount: "₹10000" },
    { title: "Runner Up Maneuverbility", amount: "₹5000" },
    { title: "Best CAE Award", amount: "₹5000" },
    { title: "Runner Up CAE Award", amount: "Trophy" },
    { title: "Best Business Plan", amount: "₹5000" },
    { title: "Runner Up Business Plan", amount: "Trophy" },
    { title: "Best Innovation", amount: "₹10000" },
    { title: "Lightest Weight", amount: "Trophy" },
    { title: "First TI Qualification", amount: "Trophy" },
    { title: "Best Traction", amount: "₹10000" },
    { title: "Runner Up Traction", amount: "₹5000" },
    { title: "Dronacharya Award(Faculty)", amount: "₹5000" },
    { title: "Best Women Team", amount: "₹5000" },
    { title: "Best Driver Award", amount: "₹5000" },
    { title: "Clean Pit Award", amount: "Trophy" },
    { title: "Most Hospitable Team Award", amount: "Trophy" },
    { title: "Emerging Team Award", amount: "Trophy" },
    { title: "People Choice Award", amount: "₹5000" },
    { title: "Suprise Award", amount: "₹5000" },
  ];

  const [showAll, setShowAll] = useState(false);
  const visibleAwards = showAll ? awards : awards.slice(0, 3);

  return (
    <section className="prizes-section" id="prizes">
      <h2 className="section-title">Prizes & Awards</h2>
      <p className="section-subtitle">
        Compete for incredible prizes and recognition. The top performers will
        be rewarded handsomely for their skills.
      </p>

      <div className="prize-grid">
        {prizes.map((prize, index) => (
          <div className="prize-card" key={index}>
            <div
              className="prize-icon"
              style={{ backgroundColor: prize.color }}
            >
            <i className="fa-solid fa-trophy" id="icon"></i>
            </div>
            <h4 className="place">{prize.place}</h4>
            <h3 className="title">{prize.title}</h3>
            <h2 className="amount" style={{ color: prize.color }}>
              {prize.amount}
            </h2>
            <ul className="benefits">
              {prize.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <section
        className="special-awards container"
        aria-labelledby="special-awards-title"
      >
        <div className="awards-inner">
          <div className="awards-header">
            <span className="gift"> <i className="fa-solid fa-trophy"></i></span>
            <h3 id="special-awards-title">Other Awards</h3>
          </div>

          <div className="awards-grid">
            {visibleAwards.map((a, i) => (
              <div key={i} className="award-card" role="article">
                <div className="award-title">{a.title}</div>
                <div className="award-amount">{a.amount}</div>
              </div>
            ))}
          </div>

          <button
            className="show-more-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less ▲" : "Show More ▼"}
          </button>
        </div>
      </section>
    </section>
  );
}
